import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
export var FileDescriptionStyled = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  font-weight: normal;\n  ", "\n\n  svg {\n    font-size: 1rem;\n    margin-right: 0.5rem;\n  }\n"], ["\n  display: flex;\n  font-weight: normal;\n  ", "\n\n  svg {\n    font-size: 1rem;\n    margin-right: 0.5rem;\n  }\n"])), function (_a) {
    var onClick = _a.onClick;
    return (typeof onClick === 'function' ? 'cursor: pointer;' : '');
});
var templateObject_1;
